export const subMenu = () => {
  const openSubMenu = (menuItem, submenu) => {
    const parentLi = menuItem.parentElement;
    parentLi.classList.add("submenu-open");
    submenu.classList.add("isOpened");
  };

  const closeSubMenu = (menuItem, submenu) => {
    const parentLi = menuItem.parentElement;
    parentLi.classList.remove("submenu-open");
    submenu.classList.remove("isOpened");
  };

  document.addEventListener("click", (event) => {
    const menuItem = event.target.closest(
      ".menu-item-has-children > a:first-child"
    );

    if (!menuItem) return;

    const submenu = menuItem.nextElementSibling;
    if (!submenu || !submenu.classList.contains("sub-menu")) return;

    event.preventDefault();
    event.stopPropagation();

    const isOpen = menuItem.parentElement.classList.contains("submenu-open");

    document.querySelectorAll(".submenu-open").forEach((openLi) => {
      if (openLi !== menuItem.parentElement) {
        const openSubmenu = openLi.querySelector(".sub-menu");
        closeSubMenu(openLi.querySelector("a:first-child"), openSubmenu);
      }
    });

    if (!isOpen) {
      openSubMenu(menuItem, submenu);
    } else {
      closeSubMenu(menuItem, submenu);
    }
  });

  document.addEventListener("click", (event) => {
    if (!event.target.closest(".menu-item-has-children")) {
      document.querySelectorAll(".submenu-open").forEach((openLi) => {
        const openSubmenu = openLi.querySelector(".sub-menu");
        closeSubMenu(openLi.querySelector("a:first-child"), openSubmenu);
      });
    } 
  });
}; 
 